import * as ko from "knockout";
import {ErrorObject} from "../../../../../error/ErrorObject";
import {ICompanySyncstep, ICompanySyncstepParameter, IExportAttribute} from "../../../../../index";
import {isNullOrUndefined} from "../../../../../util/misc";
import {KOSubscriptionTracker} from "../../../../../util/KOSubscriptionTracker";
import {lm} from "../../../../../appContext";
import {IComboboxV2Options} from "../../../../combobox/v2";
import {IMessageFlowDropdownOption} from "./Abstract";

export class Config {
    key: KnockoutObservable<string> = ko.observable('')
    value: KnockoutObservable<string | boolean> = ko.observable<string | boolean>('')
    selectedMessageIds: KnockoutObservableArray<string> = ko.observableArray<string>([])
    messageFlowToAdd: KnockoutObservable<IMessageFlowDropdownOption | null> = ko.observable(null)
    eo_key: ErrorObject = new ErrorObject()
    eo_value: ErrorObject = new ErrorObject()
    id: number;
    isDeleted = ko.observable(false)
    public companysyncstepid: ICompanySyncstep['id'];
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker()

    constructor(
        private config: ICompanySyncstepParameter,
        private allSyncstepParameters: IExportAttribute[],
        private messageFlowOptions: KnockoutObservableArray<IMessageFlowDropdownOption> = ko.observableArray<IMessageFlowDropdownOption>([]),
    ) {
        this.kosub.subscribe(this.key, (key: string) => {
            const val = this.covertValueToAttributeType(key, this.value())
            this.value(val)
        })
        this.kosub.subscribe(this.selectedMessageIds, (ids: string[]) => {
            this.value(ids.filter(Boolean).join(','))
        })
        this.value(config.value ?? '')
        this.selectedMessageIds(
            String(config.value ?? '')
                .split(',')
                .map(id => id.trim())
                .filter(Boolean)
        )
        this.key(config.keyvalue ?? undefined)
        this.id = config.id ?? 0
        this.companysyncstepid = config.companysyncstepid ?? null

        this.eo_key.addValidator({
            fn: () => !!this.key(),
            message: 'invalid value',
        })
    }

    public selectedMessageFlows = ko.pureComputed(() => this.selectedMessageIds().map(id => ({
        id,
        label: this.messageFlowOptions().find(o => o.idAsString == id)?.label ?? '#' + id,
        remove: () => this.selectedMessageIds.remove(id),
    })))

    public getMessageFlowComboboxParams(): IComboboxV2Options<IMessageFlowDropdownOption> {
        return {
            inputAttrs: {placeholder: lm.t('choose|td')},
            data: this.messageFlowOptions,
            selectionMode: 'pick',
            option: {
                constrain: o => !this.selectedMessageIds().includes(o.idAsString),
                label: o => o.label,
            },
            selected: this.messageFlowToAdd,
            onSelect: (o) => {
                if (o && !this.selectedMessageIds().includes(o.idAsString)) {
                    this.selectedMessageIds.push(o.idAsString)
                }
            },
        }
    }

    public isChanged(): boolean {
        const a = this.isCreated();
        const b = this.isUpdated();
        const c = this.isDeleted();
        return a || b || c
    }

    public isCreated(): boolean {
        return !this.id && !this.isDeleted()
    }

    public isUpdated(): boolean {
        const data = this.getSubmitData();
        const a = !!data.id
        const b = data.keyvalue !== this.config.keyvalue;
        const c = data.value !== this.config.value;
        return a && (b || c)
    }

    public getSubmitData(): ICompanySyncstepParameter {
        const rawValue = this.value();
        return {
            companysyncstepid: this.companysyncstepid,
            id: this.id,
            keyvalue: this.key(),
            value: isNullOrUndefined(rawValue) ? '' : rawValue.toString(),
        }
    }

    private getExportAttribute(key: IExportAttribute['name'] = this.key()): IExportAttribute {
        return this.allSyncstepParameters.find(o => o.name == key)!;
    }

    private covertValueToAttributeType(key: string, val: any): string | boolean {
        const strVal = String(val);
        switch (this.getExportAttribute(key)?.type.toLowerCase()) {
            case 'bool': {
                return strVal.toLowerCase() === 'true'
            }
            default: {
                if (isNullOrUndefined(val)) {
                    return ''
                }
                return strVal
            }
        }

    }

    dispose() {
        this.kosub.unsuscribeAll()
    }


}